<template>
  <div @click.stop="() => { }" ref="participants-dropdown"
    class="participants-dropdown bg-white p-3 cursor-default font-body" style="z-index: 2;">
    <div class="inner-wrapper">
      <div class="row mb-4">
        <div class="col-12 d-flex flex-row nowrap justify-content-between">
          <span class="heading text-start">{{
            content.planningSearch_participantsContents_whoDeparts
          }}
            ?</span>
          <ClsBtn @click="handleCloseClick" />
        </div>
      </div>
      <div class="row d-flex mb-2">
        <div class="col-12 d-flex flex-row justify-content-between align-items-start">
          <div class="text-start">
            {{
              content.planningSearch_participantsContents_numberOfParticipants
            }}
          </div>
 
          <AddRemove :num="data.participants.length" :maxVal="maxParticipants" :minVal="1" @plus="handlePlusClick"
            @minus="handleMinusClick" />
        </div>
      </div>
      <div class="border-gray border-bottom my-3"></div>
      <div v-if="shouldShowMaxParticipantsMessage" class="p-1 py-2 bg-blue-100 text-start text-primary-blue mb-3">
        <div class="font-size-14 font-weight-700 pb-2 d-flex align-items-center">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" color="var(--blue-900)"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_567_15970)">
              <path
                d="M10.0106 7.23167C10.4509 7.23167 10.8078 6.87475 10.8078 6.43447C10.8078 5.99419 10.4509 5.63727 10.0106 5.63727C9.5703 5.63727 9.21338 5.99419 9.21338 6.43447C9.21338 6.87475 9.5703 7.23167 10.0106 7.23167Z"
                fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
              <path
                d="M9.99997 18.5357C14.7141 18.5357 18.5357 14.7141 18.5357 9.99997C18.5357 5.28581 14.7141 1.46423 9.99997 1.46423C5.28581 1.46423 1.46423 5.28581 1.46423 9.99997C1.46423 14.7141 5.28581 18.5357 9.99997 18.5357Z"
                stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
              <path d="M9.99072 14.4582V9.62195" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" />
            </g>
            <defs>
              <clipPath id="clip0_567_15970">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="ps-1 caption-strong text-start">
            {{ content.planningSearch_maxParticipants_title }}
          </span>
        </div>
        <div class="caption text-start">
          {{ content.planningSearch_maxParticipants_text }}
        </div>
      </div>
      <div v-if="!isYoonly" class="p-1 py-2 bg-blue-100 text-start text-primary-blue">
        <div class="font-size-14 font-weight-700 pb-2">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" color="var(--blue-900)"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_567_15968)">
              <path
                d="M10.0106 7.23167C10.4509 7.23167 10.8078 6.87475 10.8078 6.43447C10.8078 5.99419 10.4509 5.63727 10.0106 5.63727C9.5703 5.63727 9.21338 5.99419 9.21338 6.43447C9.21338 6.87475 9.5703 7.23167 10.0106 7.23167Z"
                fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
              <path
                d="M9.99997 18.5357C14.7141 18.5357 18.5357 14.7141 18.5357 9.99997C18.5357 5.28581 14.7141 1.46423 9.99997 1.46423C5.28581 1.46423 1.46423 5.28581 1.46423 9.99997C1.46423 14.7141 5.28581 18.5357 9.99997 18.5357Z"
                stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
              <path d="M9.99072 14.4582V9.62195" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" />
            </g>
            <defs>
              <clipPath id="clip0_567_15968">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="ps-1 caption-strong text-start">{{
            content.planningSearch_ages_travelers
          }}</span>
        </div>
        <div class="caption text-start mt-2">
          {{ content.planningSearch_ages_travelers_to_add }}
        </div>
      </div>
 
      <div class="row mb-2 pt-2">
        <div class="col-12 px-0 py-lg-0 py-5">
          <div v-if="!isYoonly" class="mb-3 d-flex flex-row px-3">
            <div class="col-8 font-font-weight-600 font-size-16 text-start">
              {{ content.planningSearch_participantsContents_firstName }}
            </div>
            <div class="col-4 font-size-16 text-start d-flex flex-row flex-wrap p-0">
              <span class="me-1 font-font-weight-600">{{
                content.planningSearch_participantsContents_age
              }}</span>
              <span class="font-size-12">{{
                content.planningSearch_participantsContents_age_at_departure
              }}</span>
            </div>
          </div>
          <div v-if="!isYoonly" class="participants-list px-3">
            <div v-for="(participant, participant_i) in data.participants" :key="participant_i"
              class="participant-age-wrapper mb-3 d-flex flex-row nowrap justify-content-between align-items-center">
              <template v-if="participant_i === 0">
                <div class="font-weight-500 font-size-16 text-start d-flex flex-column nowrap cursor-pointer">
                  <div>
                    {{
                      content.planningSearch_participantsContents_participant
                    }}
                    {{ participant_i + 1 }}
                  </div>
                  <div class="border-primary-blue" style="border-bottom: dashed 1px gray"></div>
                </div>
                <div style="height: 46px" class="col-4 text-start p-0 d-flex align-items-center">
                  <span style="padding: 6px 12px 6px 12px"> 18+ </span>
                </div>
              </template>
 
              <template v-else>
                <div class="weight-500 font-size-16 text-start d-flex flex-column nowrap">
                  <div>
                    {{
                      content.planningSearch_participantsContents_participant
                    }}
                    {{ participant_i + 1 }}
                  </div>
                  <div class="border-primary-blue" style="border-bottom: dashed 1px gray"></div>
                </div>
                <template v-if="!acceptChildren">
                  <div style="height: 46px" class="col-4 text-start p-0 d-flex align-items-center">
                    <span style="padding: 6px 12px 6px 12px"> 18+ </span>
                  </div>
                </template>
                <template v-else>
                  <div class="col-4 text-start p-0">
                    <select @change="e => handleSelect(e, participant_i)"
                      class="participant-age cursor-pointer form-control" name="" id="">
                      <option :selected="participant === age.value" v-for="(age, age_i) in participantsAgesConfig"
                        :key="age_i" :value="age.value">
                        {{ age.label }}
                      </option>
                    </select>
                  </div>
                </template>
              </template>
            </div>
          </div>
 
          <div class="mx-3">
            <button @click="handleValidateClick"
              class="button-primary primary-normal p-2 mt-2 px-3 font-font-weight-600 font-size-16 cursor-pointer w-100 d-flex align-items-center justify-content-center py-3 py-md-2 px-4">
              <span>{{ content.planner_participantsValidateChoice }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import AddRemove from '@/vue/planning/components/common/addRemove.vue'
import ClsBtn from '@/vue/common/clsBtn.vue'
import { mapState } from 'vuex'
import participantsAgesConfig from '@/config/participantsAgesConfig'
import flightPackCode from '@/config/flightPackCode'
 
export default {
 
  name: 'ParticipantsDropdown',
  components: {
    AddRemove,
    ClsBtn,
  },
  props: {
    maxParticipants: {
      type: Number,
      default: 20,
    },
    minAdults: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      participantsAgesConfig,
      data: {
        participants: [],
      },
    }
  },
  computed: {
    ...mapState(['content', 'participants', 'participantsDropdownOpen', 'acceptChildren', 'packCode']),
    shouldShowMaxParticipantsMessage() {
      return flightPackCode.includes(this.packCode) && this.data.participants.length >= 9
    },
    isYoonly() {
      return window.location.hostname.includes('yoonly')
    },
  },
  methods: {
    refreshParticipants() {
      this.data.participants = [...this.participants]
    },
    fadeIn(display = 'block') {
      this.$refs['participants-dropdown'].style.opacity = 0
      this.$refs['participants-dropdown'].style.display = display
      this.$nextTick(() => {
        this.$refs['participants-dropdown'].style.opacity = 1
      })
    },
    fadeOut() {
      this.$refs['participants-dropdown'].style.opacity = 0
      setTimeout(() => {
        this.$refs['participants-dropdown'].style.display = 'none'
      }, 150)
    },
 
    handleSelect(e, participant_i) {
      e.target.blur()
      this.data.participants[participant_i] = parseInt(e.target.value)
    },
    handleCloseClick() {
      this.$emit('closeClick')
    },
    handlePlusClick() {
      if (this.data.participants.length >= this.maxParticipants) return
      this.data.participants.push(18)
    },
    handleMinusClick() {
      if (this.data.participants.length === 1) return
      this.data.participants.pop()
    },
    handleValidateClick() {
      const adultsArray = this.data.participants.filter(age => age === 18)
      if (adultsArray.length < this.minAdults)
        return this.$emit('notEnoughAdults')
      this.$emit('setParticipants', this.data.participants)
      this.$nextTick(() => {
        this.refreshParticipants()
      })
    },
  },
  watch: {
    participantsDropdownOpen: function (newValue) {
      this.refreshParticipants()
      if (newValue) {
        this.fadeIn()
      } else {
        this.fadeOut()
      }
    },
  },
  mounted() {
    this.refreshParticipants()
    if (this.participantsDropdownOpen) {
      this.$refs['participants-dropdown'].style.display = 'block'
      this.$refs['participants-dropdown'].style.opacity = '1'
    }
  },
}
</script>
 
<style scoped>
select {
  -webkit-appearance: caret;
  -moz-appearance: auto;
  appearance: auto;
}
 
.participants-dropdown {
  display: none;
  opacity: 0;
  transition: opacity 150ms ease-in-out;
}
 
.participants-dropdown {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100001 !important;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  transition: box-shadow 150ms ease-in-out;
}
 
.participant-age {
  border-radius: var(--border-radius-card) !important;
  border: 1px solid #ced4da;
  height: calc(1.5em + 0.75rem + 10px);
}
 
.participant-age:hover {
  box-shadow: 0px 0px 0px 1px var(--primary-blue) !important;
}
 
@media (max-width: 768px) {
  .participants-dropdown {
    height: 100% !important;
  }
}
 
.participants-dropdown-close {
  width: 24px;
  height: 24px;
}
 
@media (min-width: 768px) {
  .participants-dropdown {
    border-radius: 20px;
    position: absolute;
    top: initial;
    bottom: -5px;
    transform: translateY(100%);
    overflow: visible !important;
    max-height: none;
    width: 100%;
    z-index: 901 !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    /* min-height: 422px; */
  }
 
  .participants-list {
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
 